import React from 'react';
import BootModal from './Boot-Modal';

const SupportModal = ({ show, onClose }) => (
  <BootModal show={show} title="Support" onHide={onClose}>
    <div>
      <span>Have questions or need help with the eQUIP Platform? Feel free to contact us at</span>{' '}
      <a href="mailto:equiptechsupport@electronic-therapy.com">equiptechsupport@electronic-therapy.com</a> or{' '}
      <a href="tel:800-330-0093">800-330-0093</a>
    </div>
  </BootModal>
);

export default SupportModal;
